import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useOrderService(filters: any) {
  return useQuery(
    [URL.ORDEM_SERVICO.OBTER_LISTAS, filters],
    async () => {
      const { data } = await http.get(URL.ORDEM_SERVICO.OBTER_LISTAS(filters.idUnidade, filters.idSafra), {
        params: {
          situacao: filters.situacao,
        },
      });
      
      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters && filters?.menuName === "Gestão de O.S.",
    }
  );
}

export default useOrderService;